export default __webpack_public_path__ + "static/media/lagecyDollar.de9a1bb1.png";